'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { forwardRef, useContext } from 'react';

import cx from 'classnames';
import kebabCase from 'lodash/kebabCase';
import NextLink from 'next/link';
import { usePathname } from 'next/navigation';
import PropTypes from 'prop-types';

import { BlockContext } from 'components/blocks/BlockProvider';
import Peek from 'components/ui/Peek';

import { isExternalURL, isUtilityURL } from 'utils';
import * as klaviyo from 'utils/klaviyo';

import styles from './Link.module.scss';

const Link = forwardRef(
    (
        {
            as = '',
            children = null,
            className = '',
            draggable = false,
            href = '',
            scroll = true,
            target = '',
            onClick = null,
            ...props
        },
        ref
    ) => {
        const isExternalHref = isExternalURL(href);
        const blockContext = useContext(BlockContext);
        const pathname = usePathname();
        const targetProps = {
            target: target ? target : isExternalHref ? '_blank' : null,
            rel:
                isExternalHref && target !== '_self'
                    ? 'noreferrer noopener'
                    : null,
        };
        const opensInNewTab =
            targetProps.target === '_blank' || target === '_blank';
        const newTabTitle =
            opensInNewTab && !props.title ? 'Opens in a new tab' : props.title;

        delete props.iconLeading;

        const trackingPathId = kebabCase(pathname.split('?')[0]);
        const hrefId = kebabCase(as || href);

        const handleOnClick = e => {
            if (isPeekReservationLink) {
                return;
            }
            klaviyo.trackExternalLink(href);

            onClick && onClick(e);
        };

        const isPeekReservationLink =
            typeof href === 'string' && href.includes('book.peek.com');

        return isExternalHref || isUtilityURL(href) ? (
            <>
                {isPeekReservationLink && <Peek />}
                <a
                    gtm-id={`${trackingPathId}-${
                        blockContext && blockContext.substring(0, 6)
                    }-${hrefId}`}
                    {...props}
                    {...targetProps}
                    title={newTabTitle}
                    className={cx(styles.link, className)}
                    href={as ? as : href}
                    draggable={draggable}
                    onDragStart={e => (draggable ? null : e.preventDefault())}
                    onClick={handleOnClick}
                    ref={ref}
                >
                    {children}
                </a>
            </>
        ) : (
            <NextLink
                gtm-id={`${trackingPathId}-${
                    blockContext && blockContext.substring(0, 6)
                }-${hrefId}`}
                href={as ? as : href}
                as={as}
                scroll={scroll}
                {...props}
                {...targetProps}
                title={newTabTitle}
                className={cx(styles.link, className)}
                onDragStart={e => (draggable ? null : e.preventDefault())}
                onClick={handleOnClick}
                ref={ref}
            >
                {children}
            </NextLink>
        );
    }
);

Link.propTypes = {
    as: PropTypes.string,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    draggable: PropTypes.bool,
    href: PropTypes.string,
    scroll: PropTypes.bool,
    target: PropTypes.string,
    onClick: PropTypes.func,
};

// EntryLink = EntryLink;

export default Link;
